import fetch from 'isomorphic-fetch';
import { checkStatus } from '../util';
import { ROOT } from '../../constants/root';
import { Event } from "../../GAnalytics";

export function getTree(folderId = 0) {
	Event('FTP', 'getTree', 'Acessou a pasta: ' + folderId);
	return function(dispatch, getState) {
		// Builds credentials
		const URL = `${ROOT}/folder_ftp/tree/listdir/`;		

		return fetch(URL, {
			method: 'POST',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({folderId: folderId})
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			return json;
		})
		.catch((e) => {
			console.error(e);			
		});
	};
}

export function getSearchTree(arrayOfterms) {
	return function(dispatch, getState) {		
		// Builds credentials
		const URL = `${ROOT}/folder_ftp/tree/search/`;		
		return fetch(URL, {
			method: 'POST',
			headers: {
				'Authorization': 'Token ' + getState().login.credentials.token,
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(
				{
					terms: arrayOfterms
				})
		})
		.then((response) => checkStatus(response, dispatch))
		.then((response) => response.json())
		.then((json) => {
			return json;
		})
		.catch((e) => {
			console.error(e);			
		});
	};
}

// DEPRECATED
// export function download(path) {
// 	Event('FTP', 'download', 'Fez download do arquivo: ' + path);
// 	return function(dispatch, getState) {
// 		const URL = ROOT + '/folder_ftp/file/' + getState().login.credentials.token + '/';
// 		const form = document.createElement('form');
// 		form.method = "GET";
// 		form.action = URL;

// 		// Pass param as hidden input
// 		const input = document.createElement('input');
// 		input.type = 'hidden';
// 		input.name = 'p';
// 		input.value = path;
// 		form.appendChild(input);

// 		document.body.appendChild(form);
// 		form.submit();
// 		document.body.removeChild(form);
// 	};

// }

export function setTree(tree) {
	return {
		type: "SET_TREE",
		tree
	};	
}

export function setTerms(terms) {
	Event('FTP', 'setTerms', 'Definiu palavras-chave no filtro: ' + JSON.stringify(terms));
	return {
		type: "SET_TERMS",
		terms
	};	
}


// WEBPACK FOOTER //
// ./src/state/ftp/actions.js